"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAggregatedAttributesFilter = exports.getStrategyAttributesProductFilter = exports.getStrategyAttributesExcludingDefaultFilter = exports.sortingItemToPropName = exports.sortingItemToLocalSortMap = exports.sortingItemToStrategyAttributesSortMap = exports.sortingItemToAggregatedAttributesSortMap = void 0;
const graphql_1 = require("../../../../__generated__/graphql");
const ramda_1 = require("ramda");
const attributes_1 = require("../../../constants/attributes");
const models_1 = require("../../../models");
const utils_1 = require("../../../utils");
exports.sortingItemToAggregatedAttributesSortMap = {
    [models_1.SortingItem.SortByTextAsc]: { label: graphql_1.SortOrder.Asc },
    [models_1.SortingItem.SortByTextDesc]: { label: graphql_1.SortOrder.Desc },
    [models_1.SortingItem.SortByProductCountsAsc]: { productCount: graphql_1.SortOrder.Asc },
    [models_1.SortingItem.SortByProductCountsDesc]: { productCount: graphql_1.SortOrder.Desc },
};
exports.sortingItemToStrategyAttributesSortMap = {
    [models_1.SortingItem.SortByTextAsc]: [{ label: graphql_1.OrderBy.Asc }],
    [models_1.SortingItem.SortByTextDesc]: [{ label: graphql_1.OrderBy.Desc }],
    [models_1.SortingItem.SortByProductCountsAsc]: [{ label: graphql_1.OrderBy.Asc }],
    [models_1.SortingItem.SortByProductCountsDesc]: [{ label: graphql_1.OrderBy.Asc }],
};
exports.sortingItemToLocalSortMap = {
    [models_1.SortingItem.SortByTextAsc]: (0, utils_1.sortByTextFieldCaseInsensitive)(utils_1.SortOrder.Ascend),
    [models_1.SortingItem.SortByTextDesc]: (0, utils_1.sortByTextFieldCaseInsensitive)(utils_1.SortOrder.Descend),
    [models_1.SortingItem.SortByProductCountsAsc]: (0, utils_1.sortByNumberField)(utils_1.SortOrder.Ascend),
    [models_1.SortingItem.SortByProductCountsDesc]: (0, utils_1.sortByNumberField)(utils_1.SortOrder.Descend),
};
exports.sortingItemToPropName = {
    [models_1.SortingItem.SortByTextAsc]: 'label',
    [models_1.SortingItem.SortByTextDesc]: 'label',
    [models_1.SortingItem.SortByProductCountsAsc]: 'productCount',
    [models_1.SortingItem.SortByProductCountsDesc]: 'productCount',
};
const getStrategyAttributesExcludingDefaultFilter = () => ({
    some: {
        label: {
            notIn: attributes_1.CATEGORY_DEFAULT_ENRICHED_ATTRIBUTES,
        },
    },
});
exports.getStrategyAttributesExcludingDefaultFilter = getStrategyAttributesExcludingDefaultFilter;
const getStrategyAttributesProductFilter = (filter) => {
    var _a;
    return (Object.assign(Object.assign({}, filter), { some: Object.assign(Object.assign({}, filter === null || filter === void 0 ? void 0 : filter.some), { label: Object.assign({}, (_a = filter === null || filter === void 0 ? void 0 : filter.some) === null || _a === void 0 ? void 0 : _a.label) }) }));
};
exports.getStrategyAttributesProductFilter = getStrategyAttributesProductFilter;
const getAggregatedAttributesFilter = (filter, isRequirement = false) => {
    var _a, _b;
    return (Object.assign(Object.assign({ 
        // include "In Strategy" attributes that are not associated with any products (`productCount = 0`).
        isRequirement, includeNA: true }, filter), { label: Object.assign(Object.assign({}, filter === null || filter === void 0 ? void 0 : filter.label), { notIn: (0, ramda_1.uniq)([...attributes_1.CATEGORY_DEFAULT_ENRICHED_ATTRIBUTES, ...((_b = (_a = filter === null || filter === void 0 ? void 0 : filter.label) === null || _a === void 0 ? void 0 : _a.notIn) !== null && _b !== void 0 ? _b : [])]) }) }));
};
exports.getAggregatedAttributesFilter = getAggregatedAttributesFilter;
